/**
 * Stake range validation for archive View Graph filter body.
 */

/**
 * Lab stake rule: when both from and to are set, to must be ≥ from.
 * Returns an operator-facing message or null when valid.
 */
export function validateStakeRange(
  fromStake: number | null,
  toStake: number | null,
): string | null {
  if (
    fromStake != null &&
    toStake != null &&
    Number.isFinite(fromStake) &&
    Number.isFinite(toStake) &&
    toStake < fromStake
  ) {
    return 'Stake From amount should be less than or equal to Stake To amount'
  }
  return null
}
